import { IFilterButton } from './IFilterButton'

const FilterButton = ({ isActive, title, onClick }: IFilterButton) => {
    return (
        <div onClick={onClick} className={`w-fit py-1 px-2 rounded-2xl cursor-pointer ${isActive ? 'bg-[#F4F0EA] border border-[#BBA47A]' : 'bg-[var(--input-bg-color)]'}`}>
            <div className={`text-nowrap ${isActive ? 'text-[#BBA47A]' : 'text-[var(--primary-text-color)]'} text-[.8rem]`}>{title}</div>
        </div>
    )
}

export default FilterButton